export default "__VITE_ASSET__7fd747a7__"